export const DEVELOPMENT = 'development';
export const TESTING = 'testing';
export const PRODUCTION = 'production';
const CURRENT_ENVIRONMENT = PRODUCTION;

const beforeunloadHandler = (e) => {
	const dialogText =
		'Hvis du går ut av testen vil du trenge en helt ny kode, samt starte på nytt!';
	e.returnValue = dialogText;
	if (CURRENT_ENVIRONMENT === PRODUCTION || CURRENT_ENVIRONMENT === TESTING) {
		window.localStorage.removeItem('authtoken-screening');
	}

	return dialogText;
};

const BEFORE_UNLOAD = 'beforeunload';

export function begin() {
	window.addEventListener(BEFORE_UNLOAD, beforeunloadHandler);
}

export function end() {
	window.removeEventListener(BEFORE_UNLOAD, beforeunloadHandler);
}
